import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import HeaderFive from '../../components/Header/HeaderFive';
import FooterThree from '../../components/Footer/FooterThree';
import Breadcrumb from '../../components/Breadcrumb';
import Lightbox from 'react-image-lightbox';

const ArchivePage = () => {
  const [archives, setArchives] = useState([]);
  const [expandedYears, setExpandedYears] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState('');

  useEffect(() => {
    axios.get('https://ricgop.online/api/get-archives.php')
      .then(res => {
        const data = Array.isArray(res.data.archives) ? res.data.archives : [];
        const sorted = [...data].sort((a, b) => new Date(b.archive_date) - new Date(a.archive_date));
        setArchives(sorted);
      })
      .catch(err => console.error('Error fetching archive:', err));
  }, []);

  const groupByYear = (data) => {
    return data.reduce((acc, item) => {
      const year = new Date(item.archive_date).getFullYear();
      if (!acc[year]) acc[year] = [];
      acc[year].push(item);
      return acc;
    }, {});
  };

  const groupedArchives = groupByYear(
    archives.filter(item => item.title.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const toggleYear = (year) => {
    setExpandedYears(prev => ({ ...prev, [year]: !prev[year] }));
  };

  return (
    <div className="archive-wrapper">
      <HeaderFive />
      <Breadcrumb title="Archive" />

      <main className="archive-content container">
        <div className="filter-bar mb-4">
          <input
            type="text"
            placeholder="Search events..."
            className="form-control"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {Object.keys(groupedArchives).length > 0 ? (
          Object.keys(groupedArchives).sort((a, b) => b - a).map((year) => (
            <div key={year} className="year-section mb-4">
              <button
                className="btn btn-primary w-100 text-start py-2 px-3 mb-2 d-flex justify-content-between align-items-center"
                onClick={() => toggleYear(year)}
              >
                <span>📅 {year}</span>
                <span>{expandedYears[year] ? '▲' : '▼'}</span>
              </button>

              {expandedYears[year] && (
                <div className="archive-grid">
                  {groupedArchives[year].map((event) => {
                    const archiveYear = new Date(event.archive_date).getFullYear();
                    const imageSrc = `/assets/img/archive/${archiveYear}/${event.image_path}`;
                    return (
                      <div className="archive-card" key={event.id}>
                        <div onClick={() => {
                          setLightboxImage(imageSrc);
                          setLightboxOpen(true);
                        }} style={{ cursor: 'pointer' }}>
                          <img src={imageSrc} alt={event.title} className="archive-img" />
                        </div>
                        <div className="archive-info">
                          <h4>{event.title}</h4>
                          <p className="archive-date">
                            📅 {new Date(event.archive_date).toLocaleDateString()}
                          </p>
                          {/* <Link to={`/blog-details/${event.id}`} className="archive-link">
                            Read More →
                          </Link> */}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ))
        ) : (
          <p className="text-center">No archive found.</p>
        )}
      </main>

      <FooterThree />

      {lightboxOpen && (
        <Lightbox
          mainSrc={lightboxImage}
          onCloseRequest={() => setLightboxOpen(false)}
        />
      )}

      {/* CSS in Same File */}
      <style>{`
        .archive-wrapper {
          font-family: 'Segoe UI', sans-serif;
          background: #f9f9fb;
          color: #333;
        }

        .archive-content {
          padding: 40px 15px;
        }

        .filter-bar input {
          max-width: 400px;
          margin: 0 auto;
          display: block;
        }

        .archive-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 25px;
        }

        .archive-card {
          background: #ffffff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 8px 18px rgba(0, 0, 0, 0.07);
          transition: all 0.3s ease;
        }

        .archive-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
        }

        .archive-img {
          width: 100%;
          height: 180px;
          object-fit: cover;
        }

        .archive-info {
          padding: 18px;
        }

        .archive-info h4 {
          font-size: 1.1rem;
          margin-bottom: 10px;
          color: #0d6efd;
        }

        .archive-date {
          font-size: 0.9rem;
          color: #6c757d;
          margin-bottom: 10px;
        }

        .archive-link {
          font-size: 0.95rem;
          font-weight: 500;
          color: #0d6efd;
          text-decoration: none;
          transition: color 0.3s;
        }

        .archive-link:hover {
          color: #084298;
          text-decoration: underline;
        }

        @media (max-width: 576px) {
          .archive-img {
            height: 140px;
          }
        }
      `}</style>
    </div>
  );
};

export default ArchivePage;
